import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PurchaseDate from '../../components/purchase-date';

class StartAndEndDatetimes extends Component {
  render() {
    const {
      startDatetime,
      endDatetime,
      startDatetimeTimezone,
      endDatetimeTimezone,
    } = this.props;

    if (!startDatetime && !endDatetime) return null;

    return (
      <div className="row">
        {startDatetime &&
          <div className="col-6">
            <PurchaseDate
              date={startDatetime}
              timezone={startDatetimeTimezone}
              label={
                <FormattedMessage
                  id="startEndTimes.start"
                  defaultMessage="Event starts"
                />
              }
            />
          </div>
        }
        {endDatetime &&
          <div className="col-6">
            <PurchaseDate
              date={endDatetime}
              timezone={endDatetimeTimezone}
              label={
                <FormattedMessage
                  id="startEndTimes.end"
                  defaultMessage="Event ends"
                />
              }
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ purchases }) => {
  const purchase = purchases.byId[purchases.current];
  const {
    startDatetime,
    endDatetime,
    startDatetimeTimezone,
    endDatetimeTimezone,
  } = purchase.product;

  return {
    startDatetime,
    endDatetime,
    startDatetimeTimezone,
    endDatetimeTimezone,
  };
};

export default connect(mapStateToProps)(StartAndEndDatetimes);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-claim/start-end-datetimes.container.js